export default "__VITE_ASSET__C4gCrFh7__"